import { API } from 'aws-amplify';
import { useAuth } from 'src/hooks/useAuth';
import { getDefaultTimeRangeValue } from 'src/utils/helpers';
import { getDataSourceOverride } from 'src/utils/dataSource';

export const useApiWrapper = () => {
  const { getAuthToken } = useAuth();
  const fetchPostApi = async <T>({
    isRequiredAllDetails,
    elasticMetricType,
    type,
    elasticMetricSubType,
    body
  }: {
    isRequiredAllDetails?: boolean;
    type?: string;
    elasticMetricType: string;
    elasticMetricSubType?: string;
    body?: Record<string, unknown>;
  }): Promise<T> => {
    const selectedTimeRange = getDefaultTimeRangeValue();
    const dataSourceOverride = getDataSourceOverride();
    const token = await getAuthToken();
    return API.post('csweb-dashboard-api', 'getElastic', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: {
        elasticMetricType,
        isRequiredAllDetails,
        selectedTimeRange,
        ...(type && { type }),
        ...(elasticMetricSubType && { elasticMetricSubType }),
        // Test-only; the API ignores it in production.
        ...(dataSourceOverride !== 'default' && { dataSourceOverride }),
        ...body
      }
    });
  };
  return {
    fetchPostApi
  };
};
